import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '../styles/index.css';
import '@lionstep/ui-v2/dist/index.css';

import mantineTheme from '../mantine/mantineTheme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function MyApp({ Component, pageProps, err }) {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={mantineTheme}>
        <Component {...pageProps} err={err} />
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default MyApp;
